import { DataGetAdapter } from '../../../adapter';

export default async function DataGetUseCase(event) {
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcr.dev.bpimsapps.com');
    const isUAT = url.includes('hcr.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionrenewal.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/data/get'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/data/get'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/data/get`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/data/get`;

    const payload = {
        tables: ['parameters']
    };

    const result = await DataGetAdapter(endpoint, JSON.stringify(payload));

    return result;
}
